(() => {
  const VERSION = '20260827-v4';
  if (window.__MF_STACK_85_VERSION__ === VERSION) return;
  window.__MF_STACK_85_VERSION__ = VERSION;

  const MODE = 'stapeltasse';
  const MOCKUP = 'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-stapeltasse-295ml-mockup.png?v=1787828734';
  const PRINT = '190 × 85 mm';
  const SCALE = 85 / 95;

  const norm = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function style(root) {
    if (root.getElementById('mf-stack-85-style')) return;
    const el = document.createElement('style');
    el.id = 'mf-stack-85-style';
    el.textContent = `
      .mf-stack-product-card{display:grid;grid-template-columns:minmax(0,1fr) 92px;align-items:center;gap:10px;margin:0 0 12px;padding:10px 11px;border:1px solid rgba(255,255,255,.16);border-left:3px solid #f58220;border-radius:10px;background:#191a1c;color:#fff}
      .mf-stack-product-card__copy{display:grid;gap:3px;min-width:0}.mf-stack-product-card__copy small{color:#f58220;font-size:9px;font-weight:900;text-transform:uppercase}.mf-stack-product-card__copy strong{font-size:13px;line-height:1.2}.mf-stack-product-card__copy span{font-size:10px;color:#c7c8ca}
      .mf-stack-product-card__image{display:flex;align-items:center;justify-content:center;height:70px;border-radius:7px;background:#0e0f11;overflow:hidden}.mf-stack-product-card__image img{display:block;width:94%;height:94%;object-fit:contain}
      .mf-stack-print-badge{display:inline-flex;width:max-content;max-width:100%;margin-top:3px;padding:4px 7px;border:1px solid rgba(245,130,32,.6);border-radius:999px;background:rgba(245,130,32,.1);color:#fff!important;font-size:9px!important;font-weight:900!important}
      .mf-stack-print-editor [data-mf-stack-print-visual="1"]{transform:scaleY(${SCALE.toFixed(6)});transform-origin:center center}
      @media(max-width:749px){.mf-stack-product-card{grid-template-columns:minmax(0,1fr) 74px;padding:9px}.mf-stack-product-card__image{height:58px}.mf-stack-product-card__copy strong{font-size:12px}.mf-stack-product-card__copy span{font-size:9px}}
    `;
    root.appendChild(el);
  }

  function patchText(root) {
    root.querySelectorAll('h1,h2,h3,h4,strong,b,span,p,small,div').forEach(el => {
      if (el.children.length) return;
      const before = el.textContent || '';
      let after = before
        .replace(/190\s*[×xX]\s*95\s*mm/gi, PRINT)
        .replace(/190\s*[×xX]\s*95/gi, '190 × 85');
      if (/druckbereich/i.test(after)) after = after.replace(/\b95\s*mm\b/gi, '85 mm');
      if (/deine wei(?:ß|ss)e tasse/i.test(after)) after = after.replace(/deine wei(?:ß|ss)e tasse/ig, 'Deine Stapeltasse');
      else if (/wei(?:ß|ss)e tasse/i.test(after) && after.length < 80) after = after.replace(/wei(?:ß|ss)e tasse/ig, 'Stapelbare Keramiktasse');
      if (after !== before) el.textContent = after;
    });
  }

  function controlsCard(root) {
    const controls = root.querySelector('.controls-card');
    if (!controls || controls.querySelector('[data-mf-stack-product-card]')) return;
    const card = document.createElement('div');
    card.className = 'mf-stack-product-card';
    card.dataset.mfStackProductCard = '1';
    card.innerHTML =
      '<span class="mf-stack-product-card__copy"><small>Deine Tasse</small><strong>Stapelbare Keramiktasse · 295 ml</strong><span>Foto und Text direkt auf der Stapeltasse gestalten.</span><span class="mf-stack-print-badge">Druckbereich: ' + PRINT + '</span></span>' +
      '<span class="mf-stack-product-card__image"><img src="' + MOCKUP + '" alt="Stapelbare Keramiktasse 295 ml ohne Motiv"></span>';
    controls.insertBefore(card, controls.firstElementChild || null);
  }

  function realisticCard(root) {
    if (root.querySelector('[data-mf-stack-real-card]')) return;
    const marker = [...root.querySelectorAll('h1,h2,h3,h4,strong,b,span,p,div')].find(el => {
      if (el.closest('.controls-card')) return false;
      const text = norm(el.textContent);
      return text.includes('realistische tassenvorschau') && text.length < 80;
    });
    if (!marker) return;
    let section = marker.parentElement;
    for (let i = 0; section && section !== root && i < 5; i += 1) {
      if (section.querySelector('canvas,svg,img')) break;
      section = section.parentElement;
    }
    if (!section || section.closest('.controls-card')) return;
    section.dataset.mfStackRealSection = '1';
    const card = document.createElement('div');
    card.className = 'mf-stack-product-card';
    card.dataset.mfStackRealCard = '1';
    card.innerHTML =
      '<span class="mf-stack-product-card__copy"><small>Produktform im Designer</small><strong>Stapelbare Keramiktasse · 295 ml</strong><span>Die Vorschau zeigt die kompakte Stapeltassenform.</span><span class="mf-stack-print-badge">Bedruckbare Fläche: ' + PRINT + '</span></span>' +
      '<span class="mf-stack-product-card__image"><img src="' + MOCKUP + '" alt="Stapelbare Keramiktasse 295 ml ohne Motiv"></span>';
    section.insertBefore(card, section.firstElementChild?.nextSibling || section.firstChild);
  }

  function printArea(root) {
    const canvases = [...root.querySelectorAll('canvas,svg')].filter(el =>
      !el.closest('.controls-card') && !el.closest('[data-mf-stack-real-section]')
    );
    if (!canvases.length) return;
    canvases.sort((a,b) => {
      const ar = a.getBoundingClientRect(), br = b.getBoundingClientRect();
      return (br.width * br.height) - (ar.width * ar.height);
    });
    const visual = canvases[0];
    const section = visual.parentElement;
    if (!section) return;
    section.classList.add('mf-stack-print-editor');
    section.dataset.mfPrintWidthMm = '190';
    section.dataset.mfPrintHeightMm = '85';
    visual.dataset.mfStackPrintVisual = '1';
  }

  function enhance(host) {
    if (!host || host.dataset.mfMugMode !== MODE || !host.shadowRoot) return;
    host.dataset.mfPrintWidthMm = '190';
    host.dataset.mfPrintHeightMm = '85';
    host.dataset.mfPrintArea = '190x85';

    const bar = host.closest?.('.mf-designer-dialog')?.querySelector('.mf-designer-dialog__bar span');
    if (bar) bar.textContent = 'Stapelbare Keramiktasse · 295 ml · Druckbereich ' + PRINT;

    const root = host.shadowRoot;
    const apply = () => {
      style(root);
      patchText(root);
      controlsCard(root);
      realisticCard(root);
      printArea(root);
    };
    apply();

    if (host.__mfStack85Observer) return;
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; apply(); });
    });
    observer.observe(root, {childList:true, subtree:true});
    host.__mfStack85Observer = observer;
  }

  function boot() {
    document.querySelectorAll('[data-mf-tassen-designer-host][data-mf-mug-mode="' + MODE + '"]').forEach(enhance);
  }

  window.__MF_TASSEN_STAPELTASSE_BOOT__ = boot;
  [0,100,250,600,1200,2500].forEach(ms => setTimeout(boot, ms));
})();